import { render, staticRenderFns } from "./firmDetails.vue?vue&type=template&id=566e9a37&scoped=true&"
import script from "./firmDetails.vue?vue&type=script&lang=js&"
export * from "./firmDetails.vue?vue&type=script&lang=js&"
import style0 from "./firmDetails.vue?vue&type=style&index=0&id=566e9a37&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e9a37",
  null
  
)

export default component.exports